export default __webpack_public_path__ + "static/media/iconfinder_mongodb_1012822.15d9a29a.png";